import React, { useEffect } from "react";
import InputDate from "../../../../common/Input/InputDate";
import InputTime from "../../../../common/Input/InputTime";
import { getAllLabReport } from "../../../../../store/slices/labReportSlice";
import { useDispatch, useSelector } from "react-redux";

const CollectionReceived = ({ handleChange, radiologyReportFormData }) => {
  const dispatch = useDispatch();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const labReportId = sessionStorage.getItem("labReportId");

  const clinicId = clinicInfo?.[0]?.clinicId;
  useEffect(() => {
    dispatch(getAllLabReport({ clinicId, id: labReportId, token }));
  }, [dispatch, clinicId, labReportId, token]);

  return (
    <div className="card">
      <div className="card-body">
        <h4 className="mb-4">Collection and Received Date / Time</h4>
        <div className="row">
          <div className="col-xl-3">
            <InputDate
              name="collectionDate"
              value={radiologyReportFormData?.collectionDate}
              onChange={handleChange}
              placeholder="Collection Date"
            />
          </div>
          <div className="col-xl-3">
            <InputTime
              name="collectionTime"
              value={radiologyReportFormData?.collectionTime}
              onChange={handleChange}
              placeholder="Collection Time"
            />
          </div>
          <div className="col-xl-3">
            <InputDate
              name="receivedDate"
              value={radiologyReportFormData?.receivedDate}
              onChange={handleChange}
              placeholder="Received Date"
            />
          </div>
          <div className="col-xl-3">
            <InputTime
              name="receivedTime"
              value={radiologyReportFormData?.receivedTime}
              onChange={handleChange}
              placeholder="Received Time"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollectionReceived;
